import SimpleSelect from './simpleSelect.view';

export default SimpleSelect;
